import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';

const SponsoredLots = ({
  isBin,
  showModal,
  toggleFunction,
}) => {
  const lotLabelLowercase = isBin ? 'items' : 'lots';
  return (
    <Modal isOpen={showModal} className="step-6-modal spon-lots-modal" centered>
      <ModalHeader toggle={toggleFunction} className="pb-0 ml-4" tag="h1">
        Highlight Your {isBin ? 'Items' : 'Lots'} on Invaluable!
      </ModalHeader>
      <ModalBody className="pt-0 mx-4 mb-4">
        <p>Feature your {lotLabelLowercase} for only $249/{isBin ? 'item' : 'lot'} and get:</p>
        <Row className="mt-4">
          <Col xs={2}>
            <span className="fa-layers fa-fw fa-4x">
              <FontAwesomeIcon icon="circle" className="color-primary" />
              <FontAwesomeIcon icon="eye" inverse transform="shrink-6" color="white" />
            </span>
          </Col>
          <Col className="pl-0">
            <h3 className="font-weight-bold color-primary">More Visibility</h3>
            <p>
              Your {lotLabelLowercase} will be featured on all associated category and
              sub-category pages{isBin ? '!' : 'up to the day of your sale!' }
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={2}>
            <span className="fa-layers fa-fw fa-4x">
              <FontAwesomeIcon icon="circle" className="color-primary" />
              <FontAwesomeIcon icon="users" inverse transform="shrink-6" color="white" />
            </span>
          </Col>
          <Col className="pl-0">
            <h3 className="font-weight-bold color-primary">More {isBin ? 'Buyers' : 'Bidders'}</h3>
            <p>
              Your featured {lotLabelLowercase} wíll be viewed by the hundreds of thousands
              of {isBin ? 'buyers' : 'bidders'} that visit our category pages weekly.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={5}>
            <a
              className="w-100 btn btn-primary text-capitalize"
              href="https://site.invaluable.com/featuredlot/"
              rel="noopener noreferrer"
              target="_blank"
              onClick={() => toggleFunction()}
            >
              Select your {lotLabelLowercase}
            </a>
          </Col>
          <Col xs={5} className="d-flex align-items-center">
            <Button color="link" onClick={toggleFunction}>
              Continue to Review
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default SponsoredLots;
